import { CITY_OPTIONS } from './cities';

// Parse "Country - Region - City" strings into structured lookups.
// - Level 1 = Country (Negara)
// - Level 2 = Kota   (Province / State / big city for non-Indonesia)
// - Level 3 = Kabupaten / District (only present for Indonesia entries)
const _byCountry = {};        // legacy: country -> [full city labels "region - city"]
const _kotasByCountry = {};   // country -> [kota]
const _kabupatensByKota = {}; // "country|kota" -> [kabupaten]
const _countries = [];

for (const opt of CITY_OPTIONS) {
  const parts = opt.split(' - ').map(s => s.trim()).filter(Boolean);
  if (parts.length === 0) continue;
  const country = parts[0];
  const cityLabel = parts.slice(1).join(' - '); // legacy label
  if (!_byCountry[country]) {
    _byCountry[country] = [];
    _kotasByCountry[country] = [];
    _countries.push(country);
  }
  if (cityLabel && !_byCountry[country].includes(cityLabel)) {
    _byCountry[country].push(cityLabel);
  }
  // Kota / Kabupaten split
  const kota = parts[1] || '';
  const kabupaten = parts.slice(2).join(' - '); // may be empty
  if (kota && !_kotasByCountry[country].includes(kota)) {
    _kotasByCountry[country].push(kota);
  }
  if (kota) {
    const key = `${country}|${kota}`;
    if (!_kabupatensByKota[key]) _kabupatensByKota[key] = [];
    if (kabupaten && !_kabupatensByKota[key].includes(kabupaten)) {
      _kabupatensByKota[key].push(kabupaten);
    }
  }
}
_countries.sort((a, b) => a.localeCompare(b));
for (const c of _countries) {
  _byCountry[c].sort((a, b) => a.localeCompare(b));
  _kotasByCountry[c].sort((a, b) => a.localeCompare(b));
}
for (const k of Object.keys(_kabupatensByKota)) {
  _kabupatensByKota[k].sort((a, b) => a.localeCompare(b));
}

export const COUNTRY_OPTIONS = _countries;
export const CITIES_BY_COUNTRY = _byCountry;         // legacy shape kept
export const KOTAS_BY_COUNTRY = _kotasByCountry;
export const KABUPATENS_BY_KOTA = _kabupatensByKota;

// Parse legacy `city` string into { kota, kabupaten }.
// A `city` value may be "Bali - Badung (Kuta)" (level2 + level3) or plain
// "New York" (just level2). We split on the FIRST " - " so anything after is
// considered kabupaten.
export function splitCity(cityStr) {
  if (!cityStr) return { kota: '', kabupaten: '' };
  const idx = cityStr.indexOf(' - ');
  if (idx === -1) return { kota: cityStr.trim(), kabupaten: '' };
  return { kota: cityStr.slice(0, idx).trim(), kabupaten: cityStr.slice(idx + 3).trim() };
}

export function composeCity({ kota, kabupaten }) {
  const parts = [kota, kabupaten].map(p => (p || '').trim()).filter(Boolean);
  return parts.join(' - ');
}

export function splitDomicile(s) {
  if (!s) return { country: '', city: '', location_detail: '' };
  const parts = s.split(' - ').map(p => p.trim()).filter(Boolean);
  if (parts.length === 0) return { country: '', city: '', location_detail: '' };
  if (parts.length === 1) return { country: parts[0], city: '', location_detail: '' };
  if (parts.length === 2) return { country: parts[0], city: parts[1], location_detail: '' };
  const country = parts[0];
  const city = parts[parts.length - 1];
  const location_detail = parts.slice(1, -1).join(' - ');
  return { country, city, location_detail };
}

export function composeDomicile({ country, city, location_detail }) {
  const parts = [country, city, location_detail].map(p => (p || '').trim()).filter(Boolean);
  return parts.join(' - ');
}
